import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import _ from "lodash";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Row, Col } from "react-flexbox-grid";
import { format, parseISO } from "date-fns";
import Data from "./loaded-data";
import ButtonDelete from "./button-delete";
// import DeleteButton from "./delete-item-button";
import {connect} from 'react-redux';

const QUERY = gql`
  query($id: ID!) {
    taskById(id: $id) {
      id
      status
      file
      description
      fileErrors {
        line
        errors
      }
      completeResult {
        itemsCount
        matchedCount
        upsertedCount
        modifiedCount
      }
      layer
      createdAt
      updatedAt
    }
  }
`;

const styles = theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  },
  container: {
    marginTop: theme.spacing.unit * 2
  }
});

const MapState = {
  LOADING: "Realizando procesamiento",
  COMPLETE: "Procesamiento completado",
  ERROR: "Error al procesar"
};

const CompleteInfo = ({ status, completeResult }) => {
  if (status !== "COMPLETE" || completeResult === null) {
    return null;
  }
  const {
    itemsCount,
    matchedCount,
    upsertedCount,
    modifiedCount
  } = completeResult;
  return (
    <div>
      <Typography variant="body1" gutterBottom>
        Elementos a procesar: {itemsCount}
      </Typography>
      <Typography variant="body1" gutterBottom>
        Elementos encontrados: {matchedCount}
      </Typography>
      <Typography variant="body1" gutterBottom>
        Elementos insertados: {upsertedCount}
      </Typography>
      <Typography variant="body1" gutterBottom>
        Elementos modificados: {modifiedCount}
      </Typography>
    </div>
  );
};

const ErrorsInfo = ({ status, fileErrors }) => {
  if (status !== "ERROR" || fileErrors === null) {
    return null;
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Linea</TableCell>
          <TableCell align="right">Errores</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {fileErrors.map(row => (
          <TableRow key={row.line}>
            <TableCell component="th" scope="row">
              {row.line}
            </TableCell>
            <TableCell align="right">{row.errors.join(", ")}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

const TaskItem = ({ id, classes, query, layer, closeStatsPanel }) => {
  const [openPanel, setOpenPanel] = React.useState(false)
  return (
    <Query query={QUERY} variables={{ id }} skip={!id} pollInterval={60000}>
      {({ loading, error, data, stopPolling }) => {
        if (error || loading || _.isNil(_.get(data, "taskById"))) {
          return null;
        }
        const { taskById } = data;
        const {
          createdAt,
          status,
          completeResult,
          fileErrors,
          description
        } = taskById;
        if (status !== "LOADING") {
          stopPolling();
        }
        const parsedDate = parseISO(createdAt);
        const formatedDate = format(parsedDate, "dd/MM/yyyy hh:mm:ss aaaa");

        if(closeStatsPanel){
          setOpenPanel(false);
        }
        return (
          <ExpansionPanel onChange={(e, expanded) => setOpenPanel(expanded)} expanded={openPanel}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography className={classes.heading}>
                Carga del {formatedDate} - {description}
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Row>
                <Col xs={12} className={classes.container}>
                  <Typography>Estado: {MapState[status]}</Typography>
                </Col>
                <Col xs={12} className={classes.container}>
                  <CompleteInfo
                    status={status}
                    completeResult={completeResult}
                  />
                  <ErrorsInfo status={status} fileErrors={fileErrors} />
                </Col>
                <Col xs={12}>
                  {openPanel &&
                    <Data id={id} status={status} openPanel={openPanel} />
                  }
                </Col>
              </Row>
            </ExpansionPanelDetails>

            <ExpansionPanelActions>
              <ButtonDelete
                row={taskById}
                query={query}
                variables={{ layer }}
              />
            </ExpansionPanelActions>
          </ExpansionPanel>
        );
      }}
    </Query>
  );
};

const mapStateToProps = ({data}) => ({
  closeStatsPanel : data.get('closeStatsPanel'),
});

export default connect(mapStateToProps, null)(withStyles(styles)(TaskItem));



// WEBPACK FOOTER //
// ./src/components/admin/carto/stats/item.js